import gmx_zMixins         from '../../../../includes/Jmixins/zMixins'

// Locally declared common Data-Props & SVG Drawing Support
import lmx_Watching           from './Watching'
import lmx_Events             from './Events'
  
// Charts 
import lmx_localData          from '../primitives/localData'
import lmx_LocalValues        from './set_LocalValues'
import lmx_draw_Forms         from './draw_Forms'
import lmx_draw_Chart         from './draw_Chart'
import lmx_draw_Header        from './draw_Header'
import lmx_draw_Table         from './draw_Table'



export default {
  
  mixins: [
    gmx_zMixins, 

    // Local Mixins
    lmx_localData,
    lmx_Events,
    lmx_Watching,

    lmx_LocalValues,
    lmx_draw_Forms,
    lmx_draw_Chart,
    lmx_draw_Header,
    lmx_draw_Table,

  ],

}
